module.exports = __webpack_public_path__ + "static/media/01.e2e3ebc4.jpeg";